/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */

/** Clé du drapeau mémorisé par la mutation `form/setForms`. */
export const CONTRIBUTION_FLAG_KEY = 'ui.hasContributionForm'

/**
 * La commune exploite-t-elle des propositions citoyennes ?
 *
 * Le drapeau `contribution` vit sur le **formulaire**, pas sur le post : il n'y
 * a donc rien à déduire d'une liste de tickets. On le lit dans la dernière
 * liste de formulaires chargée et, à défaut, dans celle du chargement
 * précédent — mémorisée pour que l'onglet et les entrées de menu ne
 * clignotent pas d'un écran à l'autre, et sans appel réseau supplémentaire.
 */
export function hasContributionForms(forms) {
    if (Array.isArray(forms)) {
        return forms.some((form) => form && form.contribution)
    }
    try {
        return localStorage.getItem(CONTRIBUTION_FLAG_KEY) === '1'
    } catch (e) {
        return false
    }
}

/**
 * Mémorise le drapeau au passage d'**un** formulaire (ouverture d'une fiche,
 * enregistrement depuis l'éditeur). Un formulaire seul ne dit rien des autres :
 * on ne lève le drapeau que s'il porte des contributions, on ne le baisse
 * jamais ici — c'est le rôle de la liste complète.
 */
export function rememberContributionForm(form) {
    if (!form || !form.contribution) return
    try {
        localStorage.setItem(CONTRIBUTION_FLAG_KEY, '1')
    } catch (e) {
        /* mode privé, quota : on retombera sur l'état du store */
    }
}

/** Mémorise le drapeau au passage d'une liste de formulaires. */
export function rememberContributionForms(forms) {
    if (!Array.isArray(forms)) return
    try {
        localStorage.setItem(
            CONTRIBUTION_FLAG_KEY,
            forms.some((form) => form && form.contribution) ? '1' : '0'
        )
    } catch (e) {
        /* mode privé, quota : on retombera sur l'état du store */
    }
}
